<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <form @submit.prevent="saveProject">
                    <div class="card">
                        <div class="p-3 pb-0 card-header">
                            <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
                                <!-- Sección de Título -->
                                <div>
                                    <h6 class="mb-2 ms-2">+ Nuevo Proyecto</h6>
                                </div>
                                <div class="d-flex">
                                    <router-link to="/projects"
                                        class="btn btn-secondary d-flex align-items-center justify-content-center gap-2 mb-0">
                                        <i class="ni ni-bold-left"></i> Regresar
                                    </router-link>
                                    <button v-if="!created" class="btn btn-warning mb-0 ms-4"
                                        type="submit">Guardar</button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div v-if="created" class="d-flex justify-content-center align-items-center"
                                style="height: 50vh;">
                                <div class="text-center">
                                    <i class="bi bi-check text-warning" style="font-size: 3rem;"></i>
                                    <h4 class="fw-bold mt-3">¡Proyecto Creado!</h4>
                                    <p>Tu proyecto ha sido registrado exitosamente.</p>
                                    <button @click="goToProjectsUsers()"
                                    class="btn btn-primary mt-3 me-2 text-white">
                                        + Agregar Colaboradores
                                    </button>
                                    <button class="btn btn-warning mt-3 me-2">
                                        + Crear Otro Proyecto
                                    </button>
                                    <router-link to="/projects" class="btn btn-secondary mt-3">
                                        <div class="d-flex align-items-center">
                                            <i class="ni ni-bold-left me-1"></i> Regresar
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                            <div v-if="!created">
                                <div class="row mb-2">

                                    <!-- Tag identificador -->
                                    <div class="col-md-1">
                                        <label class="form-label">Identificador:</label>
                                        <input type="text" class="form-control" id="anio" v-model="formData.tag"
                                            placeholder="200" required>
                                    </div>
                                    
                                    <!-- Año -->
                                    <div class="col-md-1">
                                        <label class="form-label">Año:</label>
                                        <input type="number" class="form-control" id="anio" v-model="currentYear"
                                            placeholder="YY" min="0" max="99" required>
                                    </div>

                                    <!-- Consecutivo -->
                                    <div class="col-md-1">
                                        <label class="form-label">Consecutivo:</label>
                                        <input type="text" class="form-control" id="consecutivo"
                                            v-model="formData.consecutive" maxlength="4" placeholder="0001" required>
                                    </div>

                                    <!-- Proyecto / Identificador -->
                                    <div class="col-md-4">
                                        <label for="proyecto" class="form-label">Nombre:</label>
                                        <input type="text" class="form-control" id="proyecto" v-model="formData.project"
                                            placeholder="Nombre del Proyecto" required>
                                    </div>

                                    <!-- Cliente -->
                                    <div class="col-md-2">
                                        <label for="cliente" class="form-label">Cliente:</label>
                                        <select id="cliente" class="form-select" v-model="selectedClient" required>
                                            <option value="" disabled>Selecciona</option>
                                            <option v-for="c in clients" :key="c.client_id" :value="c.client_id">
                                                {{ c.client }}
                                            </option>
                                        </select>
                                    </div>

                                    <!-- Project Manager -->
                                    <div class="col-md-2">
                                        <label for="pm" class="form-label">Project Manager</label>
                                        <select id="pm" class="form-select" v-model="selectedPM" required>
                                            <option value="" disabled>Selecciona</option>
                                            <option v-for="pm in projectManagers" :key="pm.user_id" :value="pm.user_id">
                                                {{ pm.name }} {{ pm.last_name }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-1">
                                        <label for="lineaNegocio" class="form-label">Segmento:</label>
                                        <select id="lineaNegocio" class="form-select" v-model="selectedBusinessLine"
                                            required>
                                            <option value="" disabled>Selecciona</option>
                                            <option v-for="linea in businessLines" :key="linea" :value="linea">
                                                {{ linea }}
                                            </option>
                                        </select>
                                    </div>

                                </div>
                                <div class="row mb-2">
                                    <!-- Descripción -->
                                    <div class="col-10">
                                        <label for="descripcion" class="form-label">Descripción</label>
                                        <textarea id="descripcion" class="form-control" rows="4"
                                            v-model="formData.description" placeholder="Descripción del proyecto"
                                            maxlength="255"></textarea>
                                    </div>
                                    <!-- Fechas -->
                                    <div class="col-lg-2">
                                        <label>Fecha de inicio:</label>
                                        <input type="date" class="form-control" v-model="formData.start_date">
                                        <label>Fecha de fin:</label>
                                        <input type="date" class="form-control" v-model="formData.end_date">
                                    </div>
                                </div>
                                <div class="row g-3">

                                    <!-- Reportes Automáticos -->
                                    <div class="col-md-2">
                                        <label class="form-label">Reportes Automáticos</label>
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="reportesAutomaticos"
                                                v-model="formData.automatic_reports">
                                            <label class="form-check-label" for="reportesAutomaticos">
                                                {{ formData.automatic_reports ? 'Activados' : 'Desactivados' }}
                                            </label>
                                        </div>
                                    </div>

                                    <!-- Actividad -->
                                    <div class="col-md-6">
                                        <label for="actividad" class="form-label">Actividad por default (Reportes
                                            Automáticos)</label>
                                        <select id="actividad" class="form-select" v-model="selectedActivity"
                                            :disabled="!formData.automatic_reports">
                                            <option value="" disabled>Selecciona Actividad</option>
                                            <option v-for="act in activities" :key="act.activity_id"
                                                :value="act.activity_id">
                                                {{ act.activity }}
                                            </option>
                                        </select>
                                    </div>

                                    <!-- En sitio por default -->
                                    <div class="col-md-3 d-flex-">
                                        <label class="form-label">¿En planta por default? (Reportes Automáticos)</label>
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="enSitio"
                                                v-model="formData.default_on_site"
                                                :disabled="!formData.automatic_reports">
                                            <label class="form-check-label" for="enSitio">
                                                {{ formData.default_on_site ? 'Sí' : 'No' }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router';
import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const formData = ref({})

const created = ref(false)

const selectedClient = ref('')
const selectedPM = ref('')
const selectedActivity = ref('')
const selectedBusinessLine = ref('')

const currentYear = new Date().getFullYear().toString().slice(-2);

const projectRoute = ref('/projects')

const router = useRouter()

const goToProjectsUsers = () => { router.push(projectRoute.value)}

const activities = ref([])
const projectManagers = ref([])
const clients = ref([])

const businessLines = [100, 200, 300, 400, 410, 900]
//const projectUsers = ref([])

const getClients = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/clients`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        clients.value = response.data;
    } catch (error) {
        console.error("Error al cargar clientes:", error);
    }
};

const getActivities = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/user-activities`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        activities.value = response.data;
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
}

const getPMs = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/get-project-managers`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        projectManagers.value = response.data;
    } catch (error) {
        console.error("Error al cargar clientes:", error);
    }
}


const saveProject = async () => {

    let identifier = `${formData.value.tag}-${currentYear}-${formData.value.consecutive}`

    const submitData = {
        identifier: identifier,
        business_line: selectedBusinessLine.value || formData.value.business_line,
        client_id: selectedClient.value || formData.value.client_id,
        pm_id: selectedPM.value || formData.value.pm_id,
        default_activity_id: selectedActivity.value || formData.value.default_activity_id,
        year: currentYear,

        project: formData.value.project,
        consecutive: formData.value.consecutive,
        description: formData.value.description,
        automatic_reports: formData.value.automatic_reports,
        default_on_site: formData.value.default_on_site,
        start_date: formData.value.start_date,
        end_date: formData.value.end_date,
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/create-complete-project`, submitData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if(response.status == 200 && response.data.success){
            projectRoute.value = `/project-users/${response.data.id}`
            created.value = true
        }
    } catch (error) {
        console.error("Error al crear el proyecto:", error);
    }

}


onMounted(async () => {
    await getPMs()
    await getActivities()
    await getClients()
})

</script>